import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function BeforeAfterSection() {
  const antes = ['Pensar todos los días qué cocinar', 'Delivery por cansancio', 'Compras improvisadas', 'Viandas a último momento', 'Gasto hormiga en comida'];
  const despues = ['Comidas resueltas con anticipación', 'Freezer organizado y útil', 'Menos delivery', 'Más ahorro real', 'Viandas listas y prácticas'];
  return <section className="w-full bg-cream py-16 px-4 flex flex-col items-center" data-id="element-3">
      <div className="max-w-4xl w-full" data-id="element-4">
        <h2 className="text-3xl md:text-4xl font-bold text-brown-800 mb-12 text-center" data-id="element-5">
          🔄 ANTES vs DESPUÉS
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-6">
          {/* ANTES */}
          <div className="bg-[#FFF0F0] rounded-2xl p-8 shadow-sm border border-red-100" data-id="element-7">
            <div className="flex items-center justify-center gap-2 mb-8" data-id="element-8">
              <XCircle className="text-red-500" size={32} data-id="element-9" />
              <h3 className="text-2xl font-bold text-red-900" data-id="element-10">ANTES</h3>
            </div>
            <ul className="space-y-5" data-id="element-11">
              {antes.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-12">
                  <span className="text-red-500 font-bold mt-1" data-id="element-13">❌</span>
                  <span className="text-red-900 font-medium text-lg" data-id="element-14">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* DESPUÉS */}
          <div className="bg-[#F0F5EC] rounded-2xl p-8 shadow-md border border-green-200 relative transform md:-translate-y-4" data-id="element-15">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-4 py-1 rounded-full text-sm font-bold shadow-sm" data-id="element-16">
              TU NUEVA REALIDAD
            </div>
            <div className="flex items-center justify-center gap-2 mb-8 mt-2" data-id="element-17">
              <CheckCircle2 className="text-green-600" size={32} data-id="element-18" />
              <h3 className="text-2xl font-bold text-green-900" data-id="element-19">DESPUÉS</h3>
            </div>
            <ul className="space-y-5" data-id="element-20">
              {despues.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-21">
                  <span className="text-green-600 font-bold mt-1" data-id="element-22">✅</span>
                  <span className="text-green-900 font-bold text-lg" data-id="element-23">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}